import React from "react";
import { styled, Box, Checkbox, FormLabel, Slider } from "@mui/material";


const PrettoSlider = styled(Slider)({
    color: '#52af77',
    height: 5,
    padding: 10,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#000000',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&::before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
});

const AccordionFilter = ({ value, onChange, options, multiSelect = false }) => {
    const oldValue = value || [0, 75];

    const isValueEqual = (val) => {
        if (multiSelect) {
            return value.includes(val);
        } else {
            return value === val;
        }
    }

    const onChangeOptions = (selectedValue) => (event) => {
        if (multiSelect) {
            const index = value.indexOf(selectedValue)
            if (index === -1) onChange([ ...value, selectedValue ]);
            else onChange(value.filter((_, i) => i !== index))
        } else {
            if (value !== selectedValue) onChange(selectedValue);
            else onChange(undefined);
        }
    }

    const handleChange = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) return;
        if (activeThumb === 0) {
            onChange([Math.min(newValue[0], oldValue[1] - 1), oldValue[1]]);
        } else {
            onChange([oldValue[0], Math.max(newValue[1], oldValue[0] + 1)]);
        }
    };

    return (
        <>
            {options ? (
                <Box className="flex flex-col max-h-[200px] overflow-auto">
                    {options?.map((item) => (
                        <Box className="flex justify-between items-center gap-3 max-w-[380px] w-full">
                            <FormLabel className="font-['CG-Medium'] case normal-case font-[400] text-[12px] text-[#000]">{item.label}</FormLabel>
                            <Checkbox size="small" sx={{ '&.Mui-checked': { color: "#2F80ED" } }} checked={isValueEqual(item.value)} onChange={onChangeOptions(item.value)} />
                        </Box>
                    ))}
                </Box>
            ) : (
                <Box className="max-w-[350px] w-full px-3">
                    <PrettoSlider
                        value={oldValue}
                        onChange={handleChange} className='mt-[50px] text-black'
                        disableSwap max={75} min={0} valueLabelDisplay="on"
                    />
                </Box>
            )}
        </>
    )
}

export default AccordionFilter;